
import { ProgressSpinner } from 'primereact/progressspinner';
import styles from "./Loading.module.css";
        

const Loading = () => {
    return (
      <div style={{textAlign:"center", width:"100%", height:"100vh", alignContent:"center", background: "radial-gradient(circle at 50% 50%, #142F47, #21355e)", position: "fixed", top: 0, left: 0, zIndex: 99999}} className="flex justify-content-center align-items-center">
        <ProgressSpinner strokeWidth='8'/>
      </div>
        );
  };
  export default Loading;